module.exports = __webpack_public_path__ + "static/img/SouthernHydrateRidge-RA.1049445.png";